import * as React from 'react';
import { cn } from '../../utils';
import { Input } from '../Input';

export const InputComponent = React.forwardRef<
  HTMLInputElement,
  React.ComponentProps<'input'>
>(({ className, ...props }, ref) => (
  <Input
    className={cn(
      'hover:border-muted-foreground rounded-s-none rounded-e-lg',
      className
    )}
    tabIndex={-1}
    {...props}
    ref={ref}
  />
));

InputComponent.displayName = 'InputComponent';
